import { Module } from 'vuex'
import { RootState, Collection } from '../store-types'
import { MetaPayload } from '@/core/utils/pagination'
import { useBadgeSectionHttp } from '@/core/api/badge-sections'
import { BadgeSection, BadgeSectionPayload } from '@/core/models/badge-section'

export type BadgeSectionCollection = {
    data: Array<BadgeSection>,
    meta?: MetaPayload,
    links?: any
}

const state: BadgeSectionCollection = {
    data: <any>[],
    meta: <any>[],
    links: <any>[],
}

export const badgeSectionCollection: Module<BadgeSectionCollection, RootState> = {
    namespaced: true,
    state,
    mutations: {
        set: (state: BadgeSectionCollection, payload: Collection) => {
            state.data = <any>[]
            payload.data.forEach((item: BadgeSectionPayload) => {
                state.data.push(new BadgeSection(item))
            })
            state.meta = payload.meta
            state.links = payload.links
        },
    },
    actions: {
        get: <T>(context: any, payload: any): Promise<T> => {
            return new Promise<T>((resolve, reject) => {
                useBadgeSectionHttp()
                    .get(payload)
                    .then((data: any) => {
                        context.commit('set', data)
                        resolve(data as T)
                    })
                    .catch((response: any) => {
                        reject(response as T)
                    })
            })
        }
    },
    getters: {
        get: (state: BadgeSectionCollection): BadgeSectionCollection => {
            return state
        }
    }
}